/**
 * Naručeno (jela iz grupa): radnici izabrane smene sa obrocima po grupama jela, po imenu. Zahteva nasleđen stari
 * tab ReportTabGroupMealsTabOrders (companyDailyOrders, mealCategories, filters, translate).
 */
export default {
  computed: {
    isRange() {
      const { from, to } = this.filters.dates;
      return Boolean(to && from !== to);
    },
    /** Firma i pretraga su već primenjeni u starom tabu. */
    slips() {
      return this.companyDailyOrders
        .map((user) => ({
          key: user.userId,
          userId: user.userId,
          id: user.id,
          name: [user.name, user.lastname].filter(Boolean).join(" ").trim(),
          initials: [user.name, user.lastname]
            .filter(Boolean)
            .map((part) => String(part).charAt(0))
            .join(""),
          categories: this.mealCategories
            .map((category) => ({
              name: this.translate(category),
              meals: (Array.isArray(user[category]) ? user[category] : []).map((meal) => ({
                quantity: meal.quantity,
                name: this.toLatin(meal.name),
              })),
            }))
            .filter((category) => category.meals.length),
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    mealTotal() {
      return this.slips.reduce(
        (sum, slip) =>
          sum + slip.categories.reduce((inner, category) => inner + category.meals.reduce((s, meal) => s + (meal.quantity || 0), 0), 0),
        0
      );
    },
  },
};
